/**
 * @generated SignedSource<<0fa8fcc8ad0716f117b6cfe99a933e71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type OrganisationSelectorQuery$variables = Record<PropertyKey, never>;
export type OrganisationSelectorQuery$data = {
  readonly organisations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type OrganisationSelectorQuery = {
  response: OrganisationSelectorQuery$data;
  variables: OrganisationSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrganisationConnection",
    "kind": "LinkedField",
    "name": "organisations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrganisationEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganisationSelectorQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrganisationSelectorQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b0c28f9c805c17c202a855bf6fbb406d",
    "id": null,
    "metadata": {},
    "name": "OrganisationSelectorQuery",
    "operationKind": "query",
    "text": "query OrganisationSelectorQuery {\n  organisations {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4092a527a58a562bb7c79b815dbdab58";

export default node;
